import { render } from "./BrandForm.vue?vue&type=template&id=6da03ffe&scoped=true"
import script from "./BrandForm.vue?vue&type=script&lang=js"
export * from "./BrandForm.vue?vue&type=script&lang=js"

import "./BrandForm.vue?vue&type=style&index=0&id=6da03ffe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da03ffe"]])

export default __exports__